<template>
  <div class="container fixation__print">
    <div class="row">
      <div class="common__title-details">Фиксация гидроизоляции</div>
      <div class="fixation__pane">
        <div class="fixation__pane-header">
          <div class="fixation__pane-header--titles">
            <div class="title">
              <span class="title__md">Угловая</span>
              <span class="title__xs">зона С</span>
            </div>
            <div class="title">
              <span class="title__md">Парапетная</span>
              <span class="title__xs">зона D</span>
            </div>
            <div class="title">
              <span class="title__md">Центральная</span>
              <span class="title__xs">зона E</span>
            </div>
          </div>
        </div>
        <div class="fixation__pane-body">
          <div class="fixation__pane-body--item__header">
            <div class="title">Тип гидроизоляции</div>
            <div class="val">
              {{ getMaterial(sectorFromState.material.id).name }}
              {{ getMaterial(sectorFromState.material.id).thickness }}
            </div>
          </div>
          <div class="fixation__pane-body--item">
            <div class="title">Ветровое давление W+(-)</div>
            <div class="val">
              <span class="val__item">{{ sectorResultFromState.side.C.windpresure }} кПа</span>
              <span class="val__item">{{ sectorResultFromState.side.D.windpresure }} кПа</span>
              <span class="val__item">{{ sectorResultFromState.side.E.windpresure }} кПа</span>
            </div>
          </div>
          <div class="fixation__pane-body--item">
            <div class="title">Расчетная нагрузка</div>
            <div class="val">
              <span class="val__item">{{ sectorResultFromState.side.C.resistance }} Н</span>
              <span class="val__item">{{ sectorResultFromState.side.D.resistance }} Н</span>
              <span class="val__item">{{ sectorResultFromState.side.E.resistance }} Н</span>
            </div>
          </div>
          <div class="fixation__pane-body--item">
            <div class="title">Рекомендуемая ширина рулона</div>
            <div class="val">
              <span class="val__item">{{ sectorResultFromState.side.C.waterproofing_size }} м</span>
              <span class="val__item">{{ sectorResultFromState.side.D.waterproofing_size }} м</span>
              <span class="val__item">{{ sectorResultFromState.side.E.waterproofing_size }} м</span>
            </div>
          </div>
          <div class="fixation__pane-body--item last">
            <div class="title">Площадь зон</div>
            <div class="val">
              <span class="val__item">{{ sectorResultFromState.side.C.square }} м²</span>
              <span class="val__item">{{ sectorResultFromState.side.D.square }} м²</span>
              <span class="val__item">{{ sectorResultFromState.side.E.square }} м²</span>
            </div>
          </div>
          <div class="fixation__pane-body--item__header">
            <div class="title">Крепежные элементы</div>
            <div class="val">{{ sectorResultFromState.fastenersElements }}</div>
          </div>
          <div class="fixation__pane-body--item">
            <div class="title">Количество крепежа на 1 м²</div>
            <div class="val">
              <span class="val__item">
                {{ sectorResultFromState.side.C.q_fasteners_calculated_m2 }} шт.
              </span>
              <span class="val__item">
                {{ sectorResultFromState.side.D.q_fasteners_calculated_m2 }} шт.
              </span>
              <span class="val__item">
                {{ sectorResultFromState.side.E.q_fasteners_calculated_m2 }} шт.
              </span>
            </div>
          </div>
          <div class="fixation__pane-body--item">
            <div class="title">Расстояние м/у рядами крепления</div>
            <div class="val">
              <span class="val__item">
                {{ sectorResultFromState.side.C.fasteners_rowlength }} мм
              </span>
              <span class="val__item">
                {{ sectorResultFromState.side.D.fasteners_rowlength }} мм
              </span>
              <span class="val__item">
                {{ sectorResultFromState.side.E.fasteners_rowlength }} мм
              </span>
            </div>
          </div>
          <div class="fixation__pane-body--item">
            <div class="title">Шаг крепежа</div>
            <div class="val">
              <span class="val__item">
                {{ sectorResultFromState.side.C.fasteners_pitchlength }} мм
              </span>
              <span class="val__item">
                {{ sectorResultFromState.side.D.fasteners_pitchlength }} мм
              </span>
              <span class="val__item">
                {{ sectorResultFromState.side.E.fasteners_pitchlength }} мм
              </span>
            </div>
          </div>
          <div class="fixation__pane-body--item last">
            <div class="title">Количество крепежных элементов</div>
            <div class="val">
              <span class="val__item">
                {{ sectorResultFromState.side.C.q_fasteners_calculated }} шт.
              </span>
              <span class="val__item">
                {{ sectorResultFromState.side.D.q_fasteners_calculated }} шт.
              </span>
              <span class="val__item">
                {{ sectorResultFromState.side.E.q_fasteners_calculated }} шт.
              </span>
            </div>
          </div>
          <div class="fixation__pane-body--item__header">
            <div class="title">Общее количество крепежа</div>
            <div class="val"><b>{{ sectorResultFromState.fastenersTotalCount }} шт.</b></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { mapState } from 'vuex';

export default {
  props: {
    sectorFromState: Object,
  },
  data() {
    return {
    };
  },
  components: {
  },
  methods: {
    getMaterial(id) {
      return this.allMaterials[this.allMaterials.findIndex(p => p.id === id)];
    },
  },
  computed: {
    ...mapState({
      allMaterials: state => state.materials,
    }),
    sectorId() {
      return (this.$route.params.id) ? this.$route.params.id : 0;
    },
    sectorResultFromState() {
      return this.$store.getters.getSectorResult(this.sectorId);
    },
  },
};
</script>
<style lang="sass">
  .fixation
    &__pane
      width: 100%
      background: #ffffff
      border-radius: rem(4)
      +media((padding: (320: 0 rem(24) rem(16), 650: 0 rem(40) rem(26))))
      &-header, &-body--item, &-body--item__header
        display: grid
        color: $black
        font-style: normal
        font-weight: 500
        font-size: rem(14)
        line-height: rem(20)
        +media((text-align: (320: center, 650: left)))
        +media((grid-template-columns: (320: 1fr, 650: 9fr 13fr)))
      &-header
        +media((padding: (320: rem(24) 0 rem(8), 650: rem(41) 0 rem(24))))
        +media((border-bottom: (320: rem(1) solid #ECECEC, 650: none)))
        &--titles
          display: grid
          +media((grid-column-start: (320: 1, 650: 2)))
          +media((grid-template-columns: (320: repeat(3, 1fr), 650: 9fr 9fr 8fr)))
          .title
            font-weight: bold
            &__md
              +media((display: (320: none, 650: inline-block)))
            &__xs
              +media((display: (320: inline-block, 650: none)))
      &-body
        &--item
          +media((padding: (320: rem(16) 0, 650: rem(24) 0 rem(7))))
          +media((border-bottom: (320: rem(1) solid #ECECEC, 650: none)))
          &.last
            +media((padding-bottom: (320: rem(16), 650: rem(24))))
          .title
            font-weight: bold
            +media((padding-bottom: (320: rem(16), 650: 0)))
          &__header
            border-bottom: rem(1) solid #ECECEC
            +media((border-top: (320: none, 650: rem(1) solid #ECECEC)))
            +media((padding: (320: rem(16) 0, 650: rem(24) 0)))
            &:first-of-type
              border-top-color: transparent
            &:last-of-type
              border-bottom-color: transparent
            .title
              font-weight: bold
              +media((padding-bottom: (320: rem(16), 650: 0)))
            .val
              text-align: center
              grid-template-columns: 1fr
          .val
            display: grid
            grid-template-columns: 9fr 9fr 8fr
            &__item
              +media((border-right: (320: rem(1) solid $grey, 650: none)))
              &:last-of-type
                border-right-color: transparent
</style>
